/** Logo rail (modo colapsado) por defecto cuando no hay white label / MTS. */
export const SIDEBAR_DEFAULT_LOGO_RAIL_URL = '../.././../assets/images/munilyIcon.svg';

/** Logo completo (modo expandido) por defecto cuando no hay white label / MTS. */
export const SIDEBAR_DEFAULT_LOGO_FULL_URL =
  'https://munily-public-cdn.s3.amazonaws.com/Logos/dashboard/munily_logo_medium.png';
